// My Day (30-day list row 19): one call to the server for everything that is yours across every
// open project, what is waiting on someone else, and what needs a decision. The home screen
// renders it; nobody has to open a project to find their own work.
import { httpsCallable } from 'firebase/functions';
import { useQuery } from '@tanstack/react-query';
import { functions } from '../firebase';
import { useAuth } from '../auth';

export type DayKind = 'task' | 'rfi' | 'submittal' | 'co' | 'punch' | 'requisition' | 'tools' | 'quote' | 'invoice' | 'week' | string;
export interface DayRow {
  pid: string | null; project: string | null; bid: boolean;
  kind: DayKind; id: string; label: string; text: string | null; href: string;
  due: string | null; days: number | null;          // days until due (negative = late)
  who?: string | null; since?: string | null; waited: number | null;   // for "waiting on": who holds it and for how long
}
export interface DayFlag { kind: string; pid: string | null; label: string; text: string; link: string; rank: number }
export interface MyDay { today: string; weekEnd: string; office: boolean; name: string; projects: number; mine: DayRow[]; waiting: DayRow[]; decide: DayRow[]; flags: DayFlag[] }

export const MY_DAY_KEY = 'my-day';
export function useMyDay() {
  const { session } = useAuth();
  return useQuery({
    queryKey: [MY_DAY_KEY, session?.user.uid],
    enabled: !!session,
    staleTime: 2 * 60_000,
    queryFn: async () => (await httpsCallable<void, MyDay>(functions, 'myDay')()).data,
  });
}

export const KIND_LABEL: Record<string, string> = { task: 'Plan row', rfi: 'RFI', submittal: 'Submittal', co: 'Change order', punch: 'Punch item', requisition: 'Material request', tools: 'Tool request', quote: 'Vendor quote', invoice: 'Application', week: 'Timesheet', run: 'Run', pull: 'Shop pull', receive: 'Receive', send: 'Order to send' };
export const KIND_ICON: Record<string, string> = { task: 'plan', rfi: 'send', submittal: 'print', co: 'chart', punch: 'check', requisition: 'box', tools: 'wrench', quote: 'box', invoice: 'chart', week: 'clock', run: 'map', pull: 'box', receive: 'check', send: 'send' };
